<template>
  <div id="sources-page">
    <!-- page header component -->
    <page-header-component
      v-if="topics"
      :topics="topics"
      :hideValidate="false"
      icon="bi bi-layers"
      title="Sources"
    />
    <!-- page component -->
    <transition name="block">
      <div>
        <!-- top sources component -->
        <div class="row">
          <!-- most active public profile positif component -->
          <div
            v-if="display_tipe == 1 || display_tipe == 3"
            class="px-gap mb-4 h-100"
            :class="display_tipe == 1 ? 'col-md-4' : 'col-md-3'"
          >
            <top-sources-component
              title="Akun Teraktif"
              type="1"
              sentimen="1"
              top_data_type="Mentions"
            />
          </div>
          <!-- top public profile positif component -->
          <div
            v-if="display_tipe == 1 || display_tipe == 3"
            class="px-gap mb-4 h-100"
            :class="display_tipe == 1 ? 'col-md-4' : 'col-md-3'"
          >
            <top-sources-component
              title="Top Akun"
              type="2"
              sentimen="1"
              top_data_type="ESMR"
            />
          </div>
          <!-- most active site positif component -->
          <div
            v-if="display_tipe == 2 || display_tipe == 3"
            class="px-gap mb-4 h-100"
            :class="display_tipe == 2 ? 'col-md-4' : 'col-md-3'"
          >
            <top-sources-component
              title="Media Teraktif"
              type="3"
              sentimen="1"
              :is_disabled="display_tipe == 2 ? true : false"
              top_data_type="Mentions"
            />
          </div>
          <div v-if="display_tipe == 2" class="px-gap mb-4 h-100 col-md-4">
            <top-sources-component
              title="Media Teraktif"
              type="3"
              sentimen="0"
              :is_disabled="true"
              top_data_type="Mentions"
            />
          </div>
          <div v-if="display_tipe == 2" class="px-gap mb-4 h-100 col-md-4">
            <top-sources-component
              title="Media Teraktif"
              type="3"
              sentimen="-1"
              :is_disabled="true"
              top_data_type="Mentions"
            />
          </div>
          <!-- most influent user positif component -->
          <div
            v-if="display_tipe == 1 || display_tipe == 3"
            class="px-gap mb-4 h-100"
            :class="display_tipe == 1 ? 'col-md-4' : 'col-md-3'"
          >
            <top-sources-component
              title="Akun Paling Berpengaruh"
              type="4"
              sentimen="1"
              top_data_type="Followers"
            />
          </div>
        </div>
        <!-- sources component -->
        <div class="row">
          <transition name="block">
            <div v-show="mounted" class="col-md-12 px-gap">
              <div class="bg-white shade">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12 col-sm-12">
                      <tab-horizontal-component
                        v-if="topics"
                        :tabs="data_tabs"
                        :actived="default_tab"
                        :key="tab_key"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <!-- tour component -->
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import top_sources from "@/views/components/sources/top_sources.vue";
import tab_horizontal from "@/views/components/tab_horizontal.vue";
import table_medkon from "../components/sources/table_medkon.vue";
import table_medsos from "../components/sources/table_medsos.vue";

export default {
  name: "Sources",
  title: "Sources | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "top-sources-component": top_sources,
    "tab-horizontal-component": tab_horizontal,
  },
  data() {
    return {
      data_tabs: [],
      mounted: false,
      default_tab: 0,
      tab_key: 0,
      topics: null,
      id_project: this.$store.getters.user.id_project,
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      tour_steps: [],
    };
  },
  methods: {
    setDefaultTab(index) {
      this.default_tab = index;
      this.tab_key++;
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.topics = response.data;
        } else {
          this.topics = {};
        }
      });
    },
  },
  created: function () {
    this.getTopic();
    let data_tabs = [];
    if (this.$store.getters.user.project.project_detail.tipe == 1) {
      if (this.display_tipe == 2 || this.display_tipe == 3) {
        data_tabs.push({
          icon_class: "bi bi-globe-americas",
          name: "Media Konvensional",
          component: table_medkon,
        });
      }
      if (this.display_tipe == 1 || this.display_tipe == 3) {
        data_tabs.push({
          icon_class: "bi bi-heart-fill",
          name: "Media Sosial",
          component: table_medsos,
        });
      }
    } else {
      data_tabs = [
        {
          icon_class: "bi bi-heart-fill",
          name: "Media Sosial",
          component: table_medsos,
        },
      ];
    }
    this.data_tabs = data_tabs;
  },
  mounted: function () {
    this.mounted = true;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: ".input-group-prepend",
      header: {
        title: "Filter Data",
      },
      content: "Klik untuk memfilter data",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: ".form-control",
      header: {
        title: "Cari Akun",
      },
      content: "Masukan nama akun yang akan dicari kemudian tekan enter.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: ".dropdown-toggle",
      header: {
        title: "Aksi",
      },
      content:
        "Anda dapat memilih aksi yang akan dilakukan terhadap sebuah akun dengan menekan tombol ini. Anda akan mendapatkan pemberitahuan ketika akun yang ditandai memposting sesuai keyword yang dimonitor. Anda juga dapat menandai sebuah akun menjadi akun pers.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>